import React, { useCallback, useEffect, useState } from "react";
import { GoogleMap, Marker, Polyline } from "@react-google-maps/api";
import { get } from "../components/api";
import originMarker from "../assets/images/map 1.png";
import destinationMarker from "../assets/images/map_2.png";
import red from "../assets/images/red.png";
// import yellow from "../../../assets/images/yellow.png";
import green from "../assets/images/green.png";
import SocketIOComponent from "./SocketIOComponent";
import { getCompanyIdFromLC } from "../helpers/helper";
// import RunningVehicle from "../assets/images/running_vehicle.png";
// import StoppedVehicle from "../assets/images/stopped_vehicle.png";

const TripMapContainer = ({ origin, destination, tripData }) => {
  const [locationData, setLocationData] = useState([]);
  const [mapCenter, setMapCenter] = useState({
    lat: 28.612734,
    lng: 77.231178,
  });
  const [socketData, setSocketData] = useState([]);
  const [progress, setProgress] = useState([]);
  const [currentPosition, setCurrentPosition] = useState(null);
  const fetchLocation = async () => {
    const response = await get(
      `company/ltms/trip-vehicle-info/67a33754f3af620b786af3cf`
    );
    if (response.status === 200) {
      const formattedData = response.data.map((point) => ({
        lat: point.coordinates[0],
        lng: point.coordinates[1],
      }));
      setLocationData(formattedData);
      const lastLocation = response.data[response.data.length - 1];
      setMapCenter({
        lat: lastLocation.coordinates[0],
        lng: lastLocation.coordinates[1],
      });
    }
  };
  useEffect(() => {
    fetchLocation();
  }, []);

  let socketDataBuffer = [];
  function handleEvent(data) {
    if (data?.vehicleNo === tripData?.loads?.loadId?.vehicleId?.vehicleNo) {
      if (data?.speed > 0) {
        let newData = {
          lat: data?.lat,
          lng: data?.lng,
          speed: data?.speed,
          angle: data?.angle,
        };
        socketDataBuffer.push(newData);
        let tempVehicleData = locationData;
        tempVehicleData[0] = {
          ...tempVehicleData[0],
          tripVehicleStatus: data.tripVehicleStatus,
        };
        if (socketDataBuffer.length > 1) {
          setLocationData(tempVehicleData);
          setSocketData((prevData) => [...prevData, ...socketDataBuffer]);
          socketDataBuffer = []; // Clear the buffer after processing
        }
      }
    }
  }

  {
    tripData && (
      <SocketIOComponent
        endpoint="https://tsocket.fleetstakes.com:9004"
        event="load_vehicles"
        onEvent={handleEvent}
        clientId={getCompanyIdFromLC()}
      />
    );
  }

  const interpolateMovement = async (startPos, positions) => {
    const totalDuration = 1000; // Total duration for animating the entire batch
    const stepsPerTransition = 60; // Number of steps per transition between two points
    const stepDuration =
      totalDuration / (positions.length * stepsPerTransition); // Calculate step duration for the entire batch
    for (let i = 0; i < positions.length; i++) {
      const endPos = positions[i];
      const latDiff = (endPos.lat - startPos.lat) / stepsPerTransition;
      const lngDiff = (endPos.lng - startPos.lng) / stepsPerTransition;
      for (let step = 0; step < stepsPerTransition; step++) {
        const newLat = startPos.lat + latDiff * step;
        const newLng = startPos.lng + lngDiff * step;
        setCurrentPosition({
          lat: newLat,
          lng: newLng,
          angle: startPos.angle,
          speed: startPos.speed,
        });
        await sleep(stepDuration);
      }
      // After interpolating to the current position, update startPos for the next iteration
      startPos = endPos;
    }

    // Ensure the final position is set to the last point in the batch
    setCurrentPosition(positions[positions.length - 1]);
  };
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const moveObject = useCallback(async () => {
    const batchSize = 1;
    if (socketData.length > 0) {
      if (progress.length === 0) {
        setProgress([socketData[0]]);
        setCurrentPosition(socketData[0]);
      } else {
        const nextIndex = progress.length;
        const batch = socketData.slice(nextIndex, nextIndex + batchSize);
        if (batch.length > 0) {
          await interpolateMovement(currentPosition, batch); // Pass the batch to interpolateMovement
          setProgress((prevProgress) => [...prevProgress, ...batch]);
          setCurrentPosition(batch[batch.length - 1]); // Set to the last point of the batch
        }
      }
    }
  }, [progress, socketData, currentPosition]);

  useEffect(() => {
    const interval = setInterval(() => {
      moveObject();
    }, 1000);
    return () => clearInterval(interval);
  }, [moveObject]);

  const mapOptions = {
    mapTypeId: "roadmap",
    zoomControl: false,
    streetViewControl: false,
    fullscreenControl: true,
    mapTypeControl: true,
    trafficControlOptions: {
      mapTypeIds: ["roadmap", "satellite"],
      style: window.google.maps?.TrafficStyle,
    },
    clickableIcons: false,
  };
  return (
    <GoogleMap
      mapContainerStyle={{
        height: "100%",
        width: "100%",
      }}
      center={mapCenter}
      options={mapOptions}
      zoom={7}
    >
      {locationData.length > 1 && (
        <Polyline
          path={locationData}
          options={{
            strokeColor: "rgba(54, 88, 101, 1)",
            strokeOpacity: 1,
            strokeWeight: 5,
          }}
        />
      )}
      {locationData.length > 0 && (
        <Marker
          position={mapCenter}
          icon={{
            url:
              locationData[locationData.length - 1].ignition === false
                ? red
                : green,
            scaledSize: new window.google.maps.Size(20, 50),
          }}
        />
      )}
      {origin && (
        <Marker
          position={origin}
          icon={{
            url: originMarker,
            scaledSize: new window.google.maps.Size(40, 40),
          }}
        />
      )}

      {destination && (
        <Marker
          position={destination}
          icon={{
            url: destinationMarker,
            scaledSize: new window.google.maps.Size(30, 30),
          }}
        />
      )}
    </GoogleMap>
  );
};

export default TripMapContainer;
